// NL
export const bathroomDefaultNL = {
  id: '9a1c3eeb-c4aa-492d-996d-16f5bbc34a1c',
  identifier: 'bathroom-default',
}
